module.exports = __webpack_public_path__ + "img/sakuya izayoi_sc2.d970217d.png";